import Vue from 'vue'
import store from './store'
// import router from './router'
import { createRouter } from './router'

import App from './App.vue'
import './registerServiceWorker'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'dripicons/webfont/webfont.css'
import '@mdi/font/css/materialdesignicons.min.css'

import '@/filters/filters.js'
import AxiosSetup from '@/helpers/AxiosSetup'
import { EventBus } from '@/event-bus.js'

import LmBreadcrumb from './components/LmBreadcrumb.vue'
import LmStockGraph from './components/LmStockGraph.vue'
import LmChartBar from './components/charts/LmChartBar.vue'
import LmChartLine from './components/charts/LmChartLine.vue'
import LmChartPie from './components/charts/LmChartPie.vue'
import LmTable from './components/LmTable.vue'
import LmCardMore from './components/LmCardMore.vue'
import LmComponentLoading from './components/LmComponentLoading.vue'
import Vuelidate from 'vuelidate'

import './sass/_variables.sass'

// Font-awesome

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Chart from 'chart.js'
import i18n from './i18n'

Chart.defaults.global.defaultFontColor = '#6c757d'
Chart.defaults.global.defaultFontFamily = 'Nunito,sans-serif'
Chart.defaults.global.defaultFontSize = 14
Chart.defaults.global.defaultFontStyle = 'normal'
Chart.defaults.global.legend.position = 'bottom'
Chart.defaults.global.title.fontSize = 16
Chart.defaults.global.title.fontStyle = 'bold'
Chart.defaults.global.title.padding = 0

Vue.component('LmBreadcrumb', LmBreadcrumb)
Vue.component('LmStockGraph', LmStockGraph)
Vue.component('LmChartBar', LmChartBar)
Vue.component('LmChartLine', LmChartLine)
Vue.component('LmChartPie', LmChartPie)
Vue.component('LmTable', LmTable)
Vue.component('LmCardMore', LmCardMore)
Vue.component('LmComponentLoading', LmComponentLoading)

// Font awesome

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

AxiosSetup()

Vue.use(BootstrapVue)
Vue.use(Vuelidate)

Vue.config.productionTip = false

const main = async () => {
  const router = await createRouter()

  EventBus.$on('routePush', (destination) => {
    router.push(destination)
  })

  router.beforeEach((to, from, next) => {
    const noGuardRequired = ['login', '404', 'callback']
    if (!store.getters['session/isAuthenticated'] && !noGuardRequired.includes(to.name)) {
      next('/login')
    } else {
      next()
    }
  })

  router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title ? to.meta.title + ' -' : ''}  ${store.getters['settings/appName']} `
    next()
  })

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

main()
